import { STRINGS } from '@/constants/strings';
import { colors } from '@/theme/colors';
import { theme } from '@/theme/theme';
import React from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';

export type ErrorBoundaryFallbackViewProps = {
  /** Contact email shown to users. */
  contactEmail?: string;
};

const DEFAULT_CONTACT_EMAIL = 'support@uskidgolf.com';

export function ErrorBoundaryFallbackView({
  contactEmail = DEFAULT_CONTACT_EMAIL,
}: ErrorBoundaryFallbackViewProps) {
  return (
    <View style={styles.root}>
      <ScrollView contentContainerStyle={styles.container}>
        <Text style={styles.title}>{STRINGS.errors.unexpectedErrorTitle}</Text>
        <Text style={styles.message}>{STRINGS.errors.unexpectedError}</Text>

        <View style={styles.divider} />

        <Text style={styles.contact}>
          Contact support: <Text style={styles.contactEmail}>{contactEmail}</Text>
        </Text>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: theme.colors['Backgrounds/Primary'],
  },
  container: {
    flexGrow: 1,
    paddingHorizontal: 20,
    paddingVertical: 24,
    justifyContent: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: '700',
    color: theme.colors['Labels/Primary'],
    marginBottom: 8,
  },
  message: {
    fontSize: 14,
    lineHeight: 20,
    color: theme.colors['Labels/Secondary'],
    marginBottom: 16,
  },
  divider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: theme.colors['Separators/Vibrant'],
    marginVertical: 12,
  },
  contact: {
    fontSize: 13,
    color: theme.colors['Labels/Secondary'],
  },
  contactEmail: {
    fontWeight: '700',
    color: colors.Blue,
  },
});
